import * as React from "react";
import {
    List, Datagrid, TextField, EditButton, ShowButton, Edit, Show,
    SimpleForm, SimpleShowLayout, TextInput, SelectInput, NumberInput,
    DateField, Filter, DeleteButton
} from 'react-admin';

const BidFilter = (props) => (
    <Filter {...props}>
        <SelectInput label="状态" source="Status" choices={[
            { id: 'pending', name: '待确认' },
            { id: 'accepted', name: '已采纳' },
            { id: 'rejected', name: '已拒绝' },
        ]} />
    </Filter>
);

export const AgriServiceBidList = props => (
    <List {...props} filters={<BidFilter />} title="报价管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="DemandId" label="需求ID" />
            <TextField source="ProviderId" label="服务主体ID" />
            <TextField source="Quote" label="报价(元)" />
            <TextField source="QuoteUnit" label="计价单位" />
            <TextField source="Status" label="状态" />
            <TextField source="Remark" label="备注" />
            <DateField source="CreateTime" label="报价时间" showTime />
            <EditButton />
            <ShowButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const AgriServiceBidShow = props => (
    <Show {...props} title="报价详情">
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="DemandId" label="需求ID" />
            <TextField source="ProviderId" label="服务主体ID" />
            <TextField source="Quote" label="报价(元)" />
            <TextField source="QuoteUnit" label="计价单位" />
            <TextField source="Status" label="状态" />
            <TextField source="Remark" label="备注" />
            <DateField source="CreateTime" label="报价时间" showTime />
        </SimpleShowLayout>
    </Show>
);

export const AgriServiceBidEdit = props => (
    <Edit {...props} title="编辑报价">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput disabled source="DemandId" label="需求ID" />
            <TextInput disabled source="ProviderId" label="服务主体ID" />
            <NumberInput source="Quote" label="报价(元)" />
            <SelectInput source="QuoteUnit" label="计价单位" choices={[
                { id: '元/亩', name: '元/亩' },
                { id: '元/次', name: '元/次' },
            ]} />
            <SelectInput source="Status" label="状态" choices={[
                { id: 'pending', name: '待确认' },
                { id: 'accepted', name: '已采纳' },
                { id: 'rejected', name: '已拒绝' },
            ]} />
            <TextInput source="Remark" label="备注" />
        </SimpleForm>
    </Edit>
);
